import { useContext } from 'react';
import { ToastContext } from './ToastContext';

export const useToastContext = () => {
  const context = useContext(ToastContext);

  if (!context) {
    throw new Error(
      'useToastContext have to be used within ToastContextProvider',
    );
  }

  return context;
};
